import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Lock } from "lucide-react";

// ════════════════════════════════════════════════════════════════════════════
//  Aviso de SOMENTE-LEITURA para as tabelas de referência NACIONAIS (NCM, CFOP,
//  CEST, CST, CSOSN, ANP, Monofásico, alíquotas por UF, País/Estado/Cidade...).
//
//  Essas tabelas vivem no catálogo MESTRE (udisysfiscal) e são mantidas só pelo
//  suporte Udisys (admin global). O cliente comum apenas LÊ. Renderize este aviso
//  quando o usuário NÃO for admin global (use `useAuth().user?.isAdminGlobal`).
// ════════════════════════════════════════════════════════════════════════════

export function AvisoTabelaNacional() {
  return (
    <Alert>
      <Lock className="h-4 w-4" />
      <AlertTitle>Tabela nacional mantida pela Udisys</AlertTitle>
      <AlertDescription>
        Esta é uma tabela de referência nacional, exibida apenas para consulta. Para
        alterações, entre em contato com o suporte para auditoria do valor correto.
      </AlertDescription>
    </Alert>
  );
}
